import { useCallback, useState } from 'react'
import { useLocation } from 'react-router-dom'

import AuthService from '../../utilities/services/auth.service'
import SupportButton from './SupportButton'
import SupportJsdEmbed from './SupportJsdEmbed'
import SupportLauncherTint from './SupportLauncherTint'
import SupportPanel from './SupportPanel'
import { SupportProvider } from './SupportProvider'
import {
  getJsdWidgetKey,
  isSupportWidgetEnabled,
  shouldHideSupportWidget,
} from './supportWidgetUtils'

import './supportWidget.scss'

export default function SupportWidget() {
  const { pathname } = useLocation()
  const [jsdReady, setJsdReady] = useState(false)
  const [jsdFailed, setJsdFailed] = useState(false)
  const handleJsdReady = useCallback(() => setJsdReady(true), [])
  const handleJsdError = useCallback(() => setJsdFailed(true), [])
  const jsdKey = getJsdWidgetKey()
  const showOfficialLauncher = Boolean(jsdKey) && jsdReady && !jsdFailed
  const showFallbackLauncher = !showOfficialLauncher

  if (
    !isSupportWidgetEnabled() ||
    !AuthService.isLoggedIn() ||
    shouldHideSupportWidget(pathname)
  ) {
    return null
  }

  return (
    <div
      className="support-widget"
      data-testid="support-widget"
      data-embed={showOfficialLauncher ? 'jsd' : 'panel'}
    >
      {jsdKey ? (
        <SupportJsdEmbed
          widgetKey={jsdKey}
          onReady={handleJsdReady}
          onError={handleJsdError}
        />
      ) : null}
      {showOfficialLauncher ? <SupportLauncherTint /> : null}
      {showFallbackLauncher ? (
        <SupportProvider>
          <SupportButton />
          <SupportPanel />
        </SupportProvider>
      ) : null}
    </div>
  )
}
